import { AppState } from 'reducers';

export const getExpatAnswers = (state: AppState) =>
  state.genericQuestionnaire.expat;

export const getExpatDependentAnswers = (state: AppState) =>
  state.genericQuestionnaire.expat?.dependent;
